import * as React from 'react';
export const createCardsSvg = React.forwardRef(function createCardsSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M13.25.5a.75.75 0 0 1 .75.75V2.5h1.25a.75.75 0 0 1 0 1.5H14v1.25a.75.75 0 0 1-1.5 0V4h-1.25a.75.75 0 0 1 0-1.5h1.25V1.25a.75.75 0 0 1 .75-.75Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3 4.25c0-.966.784-1.75 1.75-1.75h4a.75.75 0 0 1 0 1.5h-4a.25.25 0 0 0-.25.25V6.5h6A1.5 1.5 0 0 1 12 8v1.5h1.25a.25.25 0 0 0 .25-.25v-1.5a.75.75 0 0 1 1.5 0v1.5A1.75 1.75 0 0 1 13.25 11H12v2.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 0 13.5V8a1.5 1.5 0 0 1 1.5-1.5H3V4.25ZM10.5 8h-9v1h9V8Zm0 2.5h-9v3h9v-3Z',
    }),
  );
});
createCardsSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var createCards = {
  category: 'icon',
  colorable: true,
  name: 'createCards',
  svg: createCardsSvg,
};
